import { useEffect, useState,useContext } from "react";
import { inventoryProducts } from "../Home/Home";
import styles from "./Constant.module.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { AuthContext,AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import { useNavigate } from "react-router-dom";

type controltype = {
    inventory_id: number;
    constant: number;
}

export default function Constant() {

    const [products, setProducts] = useState<inventoryProducts[]>([]);
    const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
    const [selectedManufacture, setSelectedManufacture] = useState<string>("");
    const [selectedMoldingSite, setSelectedMoldingSite] = useState<string>("");
    const [constantControl, setConstantControl] = useState<controltype[]>([]);
    const { auth,setAuth } = useContext(AuthContext) as AuthContextType;
    const [selectedOffice, setSelectedOffice] = useState<string>(auth.office? auth.office:"函館店");
const navigate = useNavigate();

    useEffect(() => {
 const checkAuth = async () => {
            try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                })
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                   setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                   return navigate("/login");
                }
                         const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                console.error(error);
            }
        }
        checkAuth();

        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            const Manufactures = data.manufacture.map((item: Object) => Object.values(item))
            setSelectManufacture(Manufactures);
        }
        fetchSelectInit();
    }, [navigate, setAuth])

    useEffect(() => {
        const fetchProducts = async () => {
            const response = await fetch(`${baseUrl}/`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "office": selectedOffice,
                    "manufacture": selectedManufacture,
                    "moldingsite": selectedMoldingSite
                })
            });
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            setProducts(data);
        }

        fetchProducts();
    }, [selectedOffice, selectedManufacture, selectedMoldingSite, navigate,setAuth])



    const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOffice(e.target.value);
    }

    const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedManufacture(e.target.value);
    }

    const handleMoldingSite = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMoldingSite(e.target.value);
    }

    const increment = (index: number) => {
        const id = products[index].inventory_id;
        const newProducts: inventoryProducts[] = products.map((item) => {
            if (item.inventory_id === id) {
                return { ...item, constant: item.constant + 1 }
            }
            return item;
        })
        setProducts(newProducts);
        let newConstantControl: controltype[] = [...constantControl];
        const duplicationcc = newConstantControl.find(item => item.inventory_id === newProducts[index].inventory_id);
        if (duplicationcc) {
            duplicationcc.constant += 1;
        } else {
            newConstantControl.push({ inventory_id: newProducts[index].inventory_id, constant: newProducts[index].constant })
        }
        setConstantControl(newConstantControl)
    }

    const decrement = (index: number) => {
        const id = products[index].inventory_id;
        const newProducts: inventoryProducts[] = products.map((item) => {
            if (item.inventory_id === id) {
                return { ...item, constant: item.constant - 1 }
            }
            return item;
        })

        setProducts(newProducts);
        let newConstantControl: controltype[] = [...constantControl];
        const duplicationcc = newConstantControl.find(item => item.inventory_id === newProducts[index].inventory_id);
        if (duplicationcc) {
            duplicationcc.constant -= 1;
        } else {
            newConstantControl.push({ inventory_id: newProducts[index].inventory_id, constant: newProducts[index].constant })
        }
        setConstantControl(newConstantControl);
    }

    const handleConstant = async () => {
        if (constantControl.length === 0) {
            return alert("定数の変更がありません。")
        } else {
            const response = await fetch(`${baseUrl}/updateconstant`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(constantControl)
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            alert(data.message);
            setConstantControl([]);
        }
    }



    return (
        <div className={styles.div}>
            <div className={styles.div2}>
                <h2 className={styles.h2}>在庫品の定数リスト</h2>
                <Link to="/ConstantRegister"><Button variant="contained" sx={{ position: "absolute", top: 25, right: 50, fontSize: 16, "@media screen and (max-width:959px)": { top: 70, right: 10, fontSize: 14 } }}>製品リストから定数を設定</Button></Link>
            </div>
            <div className={styles.selecterwrapper}>
                {auth.office?<p className={styles.p2}>支店：{auth.office}</p>:<label htmlFor="office" className={styles.label}>支店
                    <select className={styles.select} value={selectedOffice} onChange={handleOffice} id="office">
                        <option value="函館店">函館店</option>
                        <option value="札幌店">札幌店</option>
                        <option value="釧路店">釧路店</option>
                        <option value="室蘭店">室蘭店</option>
                    </select></label>}
                
                <label htmlFor="manufacture" className={styles.label}>メーカー
                    <select className={styles.select} value={selectedManufacture} onChange={handleManufacture} id="manufacture">
                        <option value="">未設定</option>
                        {selectManufacture.map(item => (<option key={item} value={item}>{item}</option>))}
                    </select></label>
                <label htmlFor="moldingsite" className={styles.label}>部位
                    <select className={styles.select} value={selectedMoldingSite} onChange={handleMoldingSite} id="moldingsite">
                        <option value="">未設定</option>
                        <option value="A%">下肢装具</option>
                        <option value="D%">上肢装具</option>
                        <option value="C%">体幹装具</option>
                    </select></label>
            </div>
            <Button variant="contained" size="large" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 14 } }} onClick={handleConstant}>定数の変更を反映する</Button>
            <div className={styles.scroll}>
                {!(products.length === 0) ? (<table className={styles.table} >
                    <thead>
                        <tr><th className={styles.th}>メーカー</th>
                            <th className={styles.th}>製品名</th>
                            <th className={styles.th}>色</th>
                            <th className={styles.th}>左右</th>
                            <th className={styles.th}>サイズ</th>
                            <th className={styles.th}>在庫数</th>
                            <th className={styles.th}>在庫定数</th>
                            <th className={styles.th} colSpan={2}>在庫定数の変更</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((item, index) => (<tr key={index} className={styles.tr}>
                            <td className={styles.td}>{item.manufacture}</td>
                            <td className={styles.td}>{item.productname}</td>
                            <td className={styles.td}>{item.color}</td>
                            <td className={styles.td}>{item.left_right}</td>
                            <td className={styles.td}>{item.size}</td>
                            <td className={styles.td}>{item.quantity}</td>
                            <td className={styles.td2}>{item.constant}</td>
                            <td className={styles.td3}><Button key={index} size="small" onClick={() => increment(index)} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 14 } }}>+1</Button></td>
                            <td className={styles.td3}><Button key={index} size="small" onClick={() => decrement(index)} disabled={item.constant < 1} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 14 } }} > -1</Button></td>
                        </tr>
                        ))}
                    </tbody>
                </table>) : <p>条件に一致する製品がありません。</p>
                }
            </div>
        </div >
    )
}